var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 6.25C9.8 8.04512 8.3675 9.5 6.6 9.5C4.8325 9.5 3.4 8.04512 3.4 6.25C3.4 4.45488 4.8325 3 6.6 3C8.3675 3 9.8 4.45488 9.8 6.25Z",
    fill: "#503EB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04194 10.4688C7.59028 10.6299 7.10495 10.7188 6.6 10.7188C5.95 10.7188 5.335 10.5715 4.7775 10.3125H4.36C2.505 10.3125 1 11.841 1 13.725V14.7812C1 15.4541 1.5375 16 2.2 16H11C11.235 16 11.4543 15.9313 11.6394 15.8126C9.53921 15.2201 8 13.2898 8 11C8 10.8162 8.01435 10.6392 8.04194 10.4688Z",
    fill: "#503EB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.469 9.25103L14.7428 9.52481C14.8373 9.6193 14.8373 9.7725 14.7428 9.867L11.8689 12.7409C11.7744 12.8354 11.6212 12.8354 11.5267 12.7409L11.2529 12.4671C11.1584 12.3727 11.1584 12.2195 11.2529 12.125L14.1268 9.251C14.2213 9.15653 14.3745 9.15653 14.469 9.25103Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7428 12.4672L14.469 12.741C14.3745 12.8354 14.2213 12.8354 14.1268 12.741L11.2529 9.867C11.1584 9.77252 11.1584 9.61931 11.2529 9.52481L11.5267 9.25103C11.6212 9.15655 11.7744 9.15655 11.8689 9.25103L14.7428 12.125C14.8373 12.2195 14.8373 12.3727 14.7428 12.4672Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackList);
export default __webpack_public_path__ + "static/media/black-list.45d8111bc53cb3d0620ea97070636c66.svg";
export { ForwardRef as ReactComponent };